<div class="login-container">
   <nb-card>
    <nb-card-header>More info</nb-card-header>

    <nb-card-body>
      <form class="login-form-container" (ngSubmit)="submit()" [formGroup]="form"
        style="display: flex; flex-direction: column; gap: 10px;">
        <input type="text" nbInput placeholder="First name" formControlName="firstName">
        <input type="text" nbInput placeholder="Last name" formControlName="lastName">
        <input type="text" nbInput placeholder="Tel" formControlName="phone" minlength="10" maxlength="10">
        <input type="email" nbInput placeholder="Email" formControlName="email">
        <textarea nbInput fullWidth placeholder="Notes" formControlName="notes" rows="3"></textarea>
        <button nbButton status="primary" type="submit" [disabled]="!form.valid">Send </button>
        <button nbButton status="basic" type="button" (click)="close()" >Cancel </button>
      </form>
    </nb-card-body>
  </nb-card>

  <div class="footer-container">
    <span class="email">For Support & More Info :
      <a href="mailto: Elad@SlickChain.com" target="_blank">Elad@SlickChain.com</a>
    </span>

  </div>
</div>
